import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagMG(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURfpHQxCBP/39/fj4+BONRhGHQvPz8/YVPaQAAAERSURBVDjL7Y4xjsMgEEV9hFDQr8IFIoiot2D6IMEBVqzn/kfYP4MdxYpxUqbYJw+x+T//z3S+8zXt8m/o+JcJ3i0MDFDOSMExTNAMHANDcM4HecJlsGSACLy/DHdwQRkYRHLaMaxYAg4SumO0A3bsLUc7vFyyc007fL9raGNDFOBobWBoGoAzHibIXBOlglkoGEq3KTaOEQWNfykRlTsEUkEFR4aMhLmUiivSEStRpdvE2sFgFq12ocqJQUVjBaa5KlAhr29IQAW3noArWoT1lAqWBuy6JGyRBF4TDgz8nsE+kfOj4SeDamW6mLO1GwMuq8nWGNGyeU6ABPC3/isec3o04DurZjXHyNfWsMNHGP4ArGXq1mbKYCQAAAAASUVORK5CYII=",
    alt: "MG"
  }, props));
}